/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
 */
export interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  assistantApiVersion: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate interface.
 */
export function instanceOfSingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate(
  value: object,
): value is SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  if (!('assistantEndpoint' in value) || value['assistantEndpoint'] === undefined) return false;
  if (!('assistantApiVersion' in value) || value['assistantApiVersion'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate {
  return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped(
    json,
    false,
  );
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    assistantEndpoint: json['assistant_endpoint'],
    assistantApiVersion: json['assistant_api_version'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreateToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerAzureOpenAiAssistantCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    assistant_endpoint: value['assistantEndpoint'],
    assistant_api_version: value['assistantApiVersion'],
    credential_id: value['credentialId'],
  };
}
